import React from 'react';
import { useAuth } from '../context/AuthContext';
import AdminDashboard from '../components/dashboard/AdminDashboard';
import EstablishmentDashboard from '../components/dashboard/EstablishmentDashboard';
import ClientDashboard from '../components/dashboard/ClientDashboard';

const DashboardPage = () => {
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full" role="status"></div>
          <p className="mt-2">Cargando usuario...</p>
        </div>
      </div>
    );
  }

  // Renderizar el dashboard según el rol del usuario
  switch (user.role) {
    case 'administrador':
      return <AdminDashboard />;
    case 'establecimiento':
      return <EstablishmentDashboard />;
    case 'cliente':
      return <ClientDashboard />;
    default:
      return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-xl font-bold text-red-600">Rol no reconocido</h2>
            <p className="text-gray-600">Tu rol de usuario no está configurado correctamente.</p>
          </div>
        </div>
      );
  }
};

export default DashboardPage;
